export default __webpack_public_path__ + "static/media/nayanz.3187c280.gif";